<template>
  <div id="d3_GIS">
    <div class="font">
      <span class="introSubTitle"><b>三维GIS平台</b></span>
      <p class="textStyle">
        基于863项目地理空间的三维建模和分析软件及其应用示范，联合国内多家优势单位，突破了大规模地上地下、室外室内三维空间数据一体化管理、高效三维空间索引与动态调度等核心技术，研制了自主知识产权的三维GIS平台软件GeoScope。
      </p>
    </div>
    <!-- <br/>   -->
    <div class="container">
      <my-video :sources="video1.sources" :options="video1.options"></my-video>
    </div>
    <div class="container">
      <my-video :sources="video2.sources" :options="video2.options"></my-video>
    </div>
    <div class="container">
      <my-video :sources="video3.sources" :options="video3.options"></my-video>
    </div>
  </div>
</template>

<script>
import myVideo from "vue-video";

export default {
  data() {
    return {
      video1: {
        sources: [
          { src: require("@/assets/static/3d-GIS-1.mp4"), type: "video/mp4" },
        ],
        options: {
          autoplay: true,
          volume: 0.6,
        },
      },
      video2: {
        sources: [
          {src: require("@/assets/static/3d-GIS-2.mp4"), type: "video/mp4"},
        ],
        options: {
          autoplay: true,
          volume: 0.6,
        },
      },
      video3: {
        sources: [
          {src: require("@/assets/static/3d-GIS-3.mp4"), type: "video/mp4"},
        ],
        options: {
          autoplay: true,
          volume: 0.6,
        },
      },
    };
  },
  components: {
    myVideo,
  },
};
</script>

<style lang="less">
#d3_GIS {
  margin-top: 20px;
  .container{
    margin-bottom: 30px;
  }
}
</style>
